import { FieldRenderProps, FieldWrapper } from '@progress/kendo-react-form'
import { MultiSelect } from '@progress/kendo-react-dropdowns'
import { Label, Error, Hint } from '@progress/kendo-react-labels'

const FormMultiSelect = (fieldRenderProps: FieldRenderProps) => {
    const {
        validationMessage,
        touched,
        label,
        id,
        valid,
        disabled,
        hint,
        wrapperStyle,
        required,
        value,
        valueObject,
        ...others
    } = fieldRenderProps

    const showValidationMessage = touched && validationMessage
    const showHint: boolean = !showValidationMessage && hint
    const hintId = showHint ? `${id}_hint` : ''
    const errorId = showValidationMessage ? `${id}_error` : ''
    const labelId = label ? `${id}_label` : ''

    return (
        <FieldWrapper style={wrapperStyle}>
            <Label
                id={labelId}
                editorId={id}
                editorValid={valid}
                editorDisabled={disabled}
            >
                {required &&
                    <span className='text-danger'>*</span>
                }
                {label} &nbsp;
                {
                    showValidationMessage &&
                    <Error id={errorId}>{validationMessage}</Error>
                }
            </Label>

            <MultiSelect
                ariaLabelledBy={labelId}
                ariaDescribedBy={`${hintId} ${errorId}`}
                valid={valid}
                id={id}
                disabled={disabled}
                value={valueObject ? valueObject : value}
                {...others}
            />

            {showHint && <Hint id={hintId}>{hint}</Hint>}
        </FieldWrapper>
    )
}

export default FormMultiSelect